var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgInquiryPointer = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 5,
  height: 8,
  viewBox: "0 0 5 8",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M1 1L4 4L1 7",
  stroke: "#21232E"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgInquiryPointer);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "d87bc9c3e2dcba17dc59bacab66fec13.svg";